import { render, staticRenderFns } from "./StockWarningModal.vue?vue&type=template&id=6ab5651a&scoped=true"
import script from "./StockWarningModal.vue?vue&type=script&lang=js"
export * from "./StockWarningModal.vue?vue&type=script&lang=js"
import style0 from "./StockWarningModal.vue?vue&type=style&index=0&id=6ab5651a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab5651a",
  null
  
)

export default component.exports